module.exports = __webpack_public_path__ + "static/media/westronglypromote-1.b9d2cd69.png";